export { default } from "./Footnotes";
export * from "./Footnotes";
export * from "./Footnotes.model";
